import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { SEO } from '../components/SEO';
import { PortalLayout } from '../components/PortalLayout';
import { PortalSidebar } from '../components/PortalSidebar';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { ScrollReveal } from '../components/ScrollReveal';
import { sectionRuleMapping } from '../data/sectionRuleMapping';
import { resourcesSidebarGroups } from '../data/resources';

const SectionMapping = () => (
  <>
    <SEO
      title="Mapping of DPDPA Sections to DPDP Rules, 2025"
      description="A cross-reference table mapping key sections of the Digital Personal Data Protection Act, 2023 to the corresponding operational Rules under the DPDP Rules, 2025."
      path="/resources/section-mapping"
    />
    <PortalLayout
      breadcrumb={<Breadcrumbs trail={[{ label: 'Resources', href: '/resources' }, { label: 'Section-to-Rule Mapping' }]} />}
      sidebar={<PortalSidebar heading="Resources" headingHref="/resources" groups={resourcesSidebarGroups} activeItemId="section-mapping" defaultOpenGroupId="resources" />}
    >
      <div data-testid="section-mapping-page" className="max-w-3xl">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-saffron-600 mb-3">Resources</p>
        <h1 className="font-serif text-3xl sm:text-4xl text-navy leading-tight mb-4">Section-to-Rule Mapping</h1>
        <p className="text-gray-600 leading-relaxed mb-10">Which DPDP Rule operationalises which section of the Act — a quick cross-reference for compliance teams.</p>
        <div className="border-t border-gray-200" data-testid="section-mapping-section">
          {sectionRuleMapping.map((m, i) => (
            <ScrollReveal key={m.sectionId} delay={(i % 6) * 0.04}>
              <div data-testid={`section-mapping-row-${m.sectionId}`} className="flex flex-col sm:flex-row gap-3 sm:gap-6 py-5 border-b border-gray-200">
                <Link to={`/dpdpa-act/section/${m.sectionId}`} className="w-48 shrink-0 group">
                  <p className="font-mono text-xs text-gray-400 mb-1">{m.section}</p>
                  <p className="font-serif text-base text-navy group-hover:text-saffron-600 transition-colors flex items-center gap-1">{m.sectionTitle} <ArrowRight size={11} className="opacity-0 group-hover:opacity-100 transition-opacity" /></p>
                </Link>
                <div className="flex-1">
                  <div className="flex flex-wrap gap-2 mb-2">
                    {m.rules.map((r) => (
                      <span key={r} className="font-mono text-[11px] uppercase tracking-widest bg-navy text-white px-2 py-1 rounded-sm">{r}</span>
                    ))}
                  </div>
                  <p className="text-sm text-gray-500 leading-relaxed">{m.note}</p>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </PortalLayout>
  </>
);

export default SectionMapping;
